var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-modal"},[_c('div',{staticClass:"loading",attrs:{"id":"loadingMagic"}},[_c('div',{attrs:{"id":"loader"}},[_c('img',{attrs:{"src":require("@/assets/images/verde.svg")}})]),_c('div',{attrs:{"id":"loader2"}},[_c('img',{attrs:{"src":require("@/assets/images/azul.svg")}})])])])
}]

export { render, staticRenderFns }